export default __webpack_public_path__ + "static/icon-15-6-0d92b0074357d5853e28c8170e84dac2.png";